import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const CapitalGainsTax = () => {
  return (
    <>
      <TopBanner content={"Capital Gains Tax"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Tax on Profits from Your Investments</h2>
          <p>
            Capital Gains Tax is the tax you pay on profits earned from selling
            an asset like shares, mutual funds, real estate, or gold. If the
            value of your asset increases and you sell it for a profit the gain
            is taxable.
          </p>
          <p>
            The tax depends on how long you held the asset before selling either
            short-term or long-term.
          </p>

          <h3>Types of Capital Gains:</h3>
          <ul>
            <li>Selling a house after 2 years → LTCG</li>
            <li>Selling shares in 10 months → STCG</li>
            <li>Selling mutual funds after 1 year → LTCG</li>
          </ul>

          <p>
            Smart planning of your investments can help reduce your capital
            gains tax liability using exemptions and indexation benefits.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default CapitalGainsTax;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
